import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ScrollText, HelpCircle, Receipt, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import LandingNav from "./LandingNav";

const LINKS = [
  { to: "/faq", key: "faq", label: "FAQ", icon: HelpCircle },
  { to: "/terms", key: "terms", label: "Syarat & Ketentuan", icon: ScrollText },
  { to: "/refund", key: "refund", label: "Kebijakan Refund", icon: Receipt },
  { to: "/contact", key: "contact", label: "Kontak", icon: Mail },
];

export default function LegalShell({ title, icon: Icon, active, children }) {
  const nav = useNavigate();
  const { user } = useAuth();
  const home = user ? "/dashboard" : "/";

  return (
    <div className="min-h-screen bg-su-bg text-su-text">
      {user ? (
        <header className="border-b-2 border-su-border sticky top-0 z-20 bg-su-bg/90 backdrop-blur">
          <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between">
            <Link to={home} className="flex items-center gap-2" data-testid="legal-logo">
              <img src="/brand/skorup_icon.png" alt="SkorUp.io" className="w-8 h-8 rounded-xl object-cover" />
              <span className="font-heading font-black">SkorUp<span className="text-su-primary">.io</span></span>
            </Link>
            <button onClick={() => nav(home)} data-testid="legal-back" className="inline-flex items-center gap-1.5 text-sm font-heading font-bold text-su-muted hover:text-su-primary transition-colors">
              <ArrowLeft className="w-4 h-4" /> Kembali
            </button>
          </div>
        </header>
      ) : (
        <LandingNav />
      )}

      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="flex items-center gap-2 mb-6">
          {Icon && <Icon className="w-7 h-7 text-su-primary" />}
          <h1 className="font-heading font-black text-3xl">{title}</h1>
        </div>
        {children}

        <div className="mt-10 pt-6 border-t-2 border-su-border flex flex-wrap items-center justify-center gap-3 text-sm">
          {LINKS.map((l) => (
            <Link key={l.key} to={l.to} data-testid={`legal-link-${l.key}`}
              className={`inline-flex items-center gap-1.5 font-heading font-bold px-4 py-2 rounded-full border-2 transition-colors ${active === l.key ? "border-su-primary text-su-primary bg-su-primary/10" : "border-su-border text-su-muted hover:text-su-primary hover:border-su-primary/50"}`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </Link>
          ))}
        </div>
        <p className="text-center text-xs text-su-muted font-medium mt-6">SkorUp.io © 2026 · Level up your score.</p>
      </main>
    </div>
  );
}
